import React from 'react';
import { isFalsy } from '../../../utils/common';
import SectionHeader from './SectionHeader';
import SimilarStudentCard from './SimilarStudentCard';
import GBSlider from './Slider';
import { COMPONENT_ID_ENUM } from './types';
var SimilarStudentProfile = function (_a) {
    var similarEnrolledStudents = _a.similarEnrolledStudents;
    if (isFalsy(similarEnrolledStudents))
        return null;
    return (React.createElement("div", { className: "lfc-bg-white lfc-p-3 lg:lfc-p-4 lfc-rounded-lg", id: COMPONENT_ID_ENUM.COURSE_DETAILS_SIMILAR_STUDENTS },
        React.createElement(SectionHeader, { title: "Students Enrolled in this Institute" }),
        React.createElement("div", { className: "lfc-mb-6" },
            React.createElement(GBSlider, { arrowPlacement: "bottom-right", sliderProps: {
                    slidesToShow: (similarEnrolledStudents === null || similarEnrolledStudents === void 0 ? void 0 : similarEnrolledStudents.length) === 1 ? 1 : 2,
                    autoplay: true,
                    speed: 950,
                    autoplaySpeed: 7500,
                    responsive: [
                        {
                            breakpoint: 475,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 2
                            }
                        }
                    ]
                }, sliderTopBoxContainerStyles: {
                    px: 0
                }, slidesToScrollCallbackCondition: function () {
                    return 2;
                } }, similarEnrolledStudents === null || similarEnrolledStudents === void 0 ? void 0 : similarEnrolledStudents.map(function (student, index) { return (React.createElement(SimilarStudentCard, { key: index, studentData: student })); })))));
};
export default SimilarStudentProfile;
//# sourceMappingURL=SimilarStudentProfile.js.map